import {DispatchFunction, IActiveFilter, IJitUsers} from '@app/models';
import { GET_ALL_JIT_USERS, GET_ALL_JIT_USERS_LOADING, JIT_USERS_COUNT } from '../constants';
import { Dispatch } from 'redux';
import { jitUsersService } from '@app/services';
import { AxiosResponse } from 'axios';

export function handleGetJitUsersData(
    orderBy: string,
    asc: string,
    top: number,
    skip: number,
    count: boolean,
    organizationId: string,
    filters?: IActiveFilter[]
): DispatchFunction {
    return (dispatch: Dispatch) => {
        if (count) {
            dispatch(getAllJitUsersLoading(true));
            dispatch(getAllJitUsers([]));
            dispatch(setJitUsersCount(0));
        }

        jitUsersService.getJitUsers(orderBy, asc, top, skip, count, organizationId, filters).then((response: AxiosResponse) => {
            if (count) {
                dispatch(setJitUsersCount(response.data['@odata.count']));
            }
            dispatch(getAllJitUsers(response.data.value));
            dispatch(getAllJitUsersLoading(false));
        });
    };
}

export function handleExpireMyReservation(id: string) {
    return () => {
        jitUsersService.postRevokeMyJitReservation(id).then(() => {});
    };
}

export function getAllJitUsers(jitUsers: IJitUsers[]) {
    return {
        payload: jitUsers,
        type: GET_ALL_JIT_USERS
    };
}

export function getAllJitUsersLoading(jitUsersLoading: boolean) {
    return {
        payload: jitUsersLoading,
        type: GET_ALL_JIT_USERS_LOADING
    };
}

export function setJitUsersCount(count: number) {
    return {
        payload: count,
        type: JIT_USERS_COUNT
    };
}
